<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerut0a-ch0601" class="chapter" epub:type="division" id="ut0a-ch06">
<header id="headerut0a-ch0601">
<h1 class="cn"><span aria-label="24" class="page" id="p24" role="doc-pagebreak"></span><a class="xref" href="#/chilashvol20005#toc">6</a></h1>
<h1 class="ct">Joint Committee on Reconstruction, Membership</h1>
<h1 class="cs" role="doc-subtitle">1865–1867<a class="fnref" href="#/chilashvol20268#fn8" id="fn8r" role="doc-noteref">8*</a></h1>
</header>
<section>
<h2 class="ahaft" id="ahaft0901">Members on the part of the Senate.</h2>
<table>
<tbody><tr>
<td>
<p class="td">Mr.</p>
</td>
<td>
<p class="td">William P. Fessenden</p>
</td>
<td>
<p class="td">of Maine [Chair].</p>
</td>
</tr>
<tr>
<td>
<p class="td">“</p>
</td>
<td>
<p class="td">James W. Grimes,</p>
</td>
<td>
<p class="td">“ Iowa.</p>
</td>
</tr>
<tr>
<td>
<p class="td">“</p>
</td>
<td>
<p class="td">Ira Harris,</p>
</td>
<td>
<p class="td">“ New York.</p>
</td>
</tr>
<tr>
<td>
<p class="td">“</p>
</td>
<td>
<p class="td">Jacob M. Howard,</p>
</td>
<td>
<p class="td">“ Michigan.</p>
</td>
</tr>
<tr>
<td>
<p class="td">“</p>
</td>
<td>
<p class="td">Reverdy Johnson,</p>
</td>
<td>
<p class="td">“ Maryland.</p>
</td>
</tr>
<tr>
<td>
<p class="td">and “</p>
</td>
<td>
<p class="td">George H. Williams,</p>
</td>
<td>
<p class="td">“ Oregon.</p>
</td>
</tr>
</tbody></table>
</section>
<section>
<h2 class="ah" id="ah0901">Members on the part of the House of Rep’s.</h2>
<table>
<tbody><tr>
<td>
<p class="td">Mr.</p>
</td>
<td>
<p class="td">Thaddeus Stevens</p>
</td>
<td>
<p class="td">of Penn’a.</p>
</td>
</tr>
<tr>
<td>
<p class="td">“</p>
</td>
<td>
<p class="td">Elihu B. Washburne,</p>
</td>
<td>
<p class="td">“ Illinois.</p>
</td>
</tr>
<tr>
<td>
<p class="td">“</p>
</td>
<td>
<p class="td">Justin S. Morrill,</p>
</td>
<td>
<p class="td">“ Vermont.</p>
</td>
</tr>
<tr>
<td>
<p class="td">“</p>
</td>
<td>
<p class="td">Henry Grider,</p>
</td>
<td>
<p class="td">“ Kentucky.</p>
</td>
</tr>
<tr>
<td>
<p class="td">“</p>
</td>
<td>
<p class="td">John A. Bingham,</p>
</td>
<td>
<p class="td">“ Ohio.</p>
</td>
</tr>
<tr>
<td>
<p class="td">“</p>
</td>
<td>
<p class="td">Roscoe Conkling,</p>
</td>
<td>
<p class="td">“ New York.</p>
</td>
</tr>
<tr>
<td>
<p class="td">“</p>
</td>
<td>
<p class="td">George S. Boutwell,</p>
</td>
<td>
<p class="td">“ Massachusetts.</p>
</td>
</tr>
<tr>
<td>
<p class="td">“</p>
</td>
<td>
<p class="td">Henry T. Blow,</p>
</td>
<td>
<p class="td">“ Missouri.</p>
</td>
</tr>
<tr>
<td>
<p class="td">and “</p>
</td>
<td>
<p class="td">Andrew J. Rogers,</p>
</td>
<td>
<p class="td">“ New Jersey.</p>
</td>
</tr>
</tbody></table>
</section>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lash-vol2-0016.vue?83bccb8c